"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountActivationResult = void 0;
var AccountActivationResult;
(function (AccountActivationResult) {
    AccountActivationResult["successful"] = "successful";
    AccountActivationResult["alreadyActivated"] = "alreadyActivated";
    AccountActivationResult["tokenInvalid"] = "tokenInvalid";
})(AccountActivationResult || (exports.AccountActivationResult = AccountActivationResult = {}));
//# sourceMappingURL=AccountActivationResult.js.map